<script setup lang="ts">
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { ja } from 'date-fns/locale';
import i18n from '@/lang/i18n';
import { computed } from 'vue';

const emits = defineEmits(['update:modelValue', 'search']);

const props = defineProps<{
  modelValue: Date[]
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
});
</script>
<template>
  <div class="w-75 d-flex mx-auto">
    <div
      style="font-size: 12px"
      class="w-100 d-flex justify-space-between"
    >
      <VueDatePicker
        :locale="ja"
        :enable-time-picker="false"
        class="w-75 m-1"
        v-model="modelValue"
        teleport="body"
        :z-index="12000"
        :formats="{ input: 'yyyy-MM-dd' }"
        :range="{
          maxRange: 31
        }"
        auto-apply
        multi-calendars
      >
        <template
          #dp-input="{ value, onInput, onFocus, onBlur }"
        >
          <div class="dp-wrapper w-100">
            <span class="dp-label">
              {{ i18n.global.t('pages.dailyReports.combineForm.dateRange') }}
            </span>
            <input
              class="dp-input"
              :value="value"
              readonly
              @focus="onFocus"
              @blur="onBlur"
              @input="onInput"
            />
          </div>
        </template>
        <template
          #clear-icon="{ clear }"
        >
          <div
            @click="clear"
          />
        </template>
      </VueDatePicker>
    </div>
  </div>
</template>
<style scoped>
.dp-wrapper {
  position: relative;
  display: inline-block;
  width: 240px;
}
.dp-label {
  position: absolute;
  top: -8px;
  left: 12px;
  background: white;
  padding: 0 6px;
  font-size: 12px;
  color: #888;
  z-index: 1;
}
.dp-input {
  width: 100%;
  padding: 14px 12px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
}
.dp-input:hover {
  border-color: #aaaeb7;
}
</style>
